<app-pwa-install-banner></app-pwa-install-banner>
<router-outlet></router-outlet>
